import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import FontIcon from 'react-toolbox/lib/font_icon'

import styles from './styles.scss'

const TimelineFontIcon = (props) => {
  switch (props.action) {
  case 'Reject': return <FontIcon styleName='icon' value='cancel'/>
  default: return <FontIcon styleName='icon' value='check_circle'/>
  }
}

export default CSSModules(TimelineFontIcon, styles)
